import * as React from "react";
const Undo = (props) => (
  <svg
    width={55.463791}
    height={67.622757}
    viewBox="0 0 55.463791 67.62276"
    id="svg1"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs id="defs1" />
    <g id="layer1" transform="translate(-56.545861,-190.81782)">
      <path
        style={{
          fill: props && props.fill ? props.fill : "#030303",
          stroke: "none",
        }}
        d="M 84.062525,190.81783 71.36253,203.51782 c -0.955278,0.95528 -4.189563,3.2417 -4.189563,4.65667 0,1.3696 3.057419,3.52452 3.977896,4.445 4.181878,4.18188 8.292452,9.50873 13.123332,12.91167 v -15.66334 c 4.51037,0.57003 8.54221,1.38908 12.27667,4.21178 2.82714,2.1369 5.089045,4.85565 6.608045,8.06489 7.87164,16.6308 -9.714155,34.47388 -26.504714,27.92693 -2.421657,-0.94424 -4.703009,-2.41026 -6.561666,-4.22336 -1.814089,-1.76964 -3.513422,-3.80628 -4.564389,-6.13524 -1.291923,-2.86292 -1.997278,-5.75035 -1.997278,-8.89 h -6.985 c 0,22.29208 26.296922,35.63256 44.238327,22.3034 2.67418,-1.98672 5.03717,-4.4486 6.81335,-7.27506 1.83927,-2.92688 3.28799,-6.1046 3.92645,-9.525 2.23135,-11.95388 -3.3417,-24.54131 -14.338125,-30.19223 -2.5749,-1.32321 -5.3877,-2.32678 -8.255,-2.76963 -1.06771,-0.16491 -3.53711,0.12513 -4.31728,-0.63859 -0.66545,-0.65142 -0.33939,-2.37997 -0.33939,-3.22955 0,-2.47271 0.74242,-6.40463 -0.21167,-8.67833 z"
        id="path1"
      />
    </g>
  </svg>
);
export default Undo;
